var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBachelors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bachelors_qualification",
    "data-name": "bachelors qualification",
    transform: "translate(-786 -502)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    width: 30,
    height: 30,
    transform: "translate(786 502)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "graduate-cap",
    transform: "translate(787 509)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M27.062,18.208a1.012,1.012,0,0,0-.576-.908V11.036a.193.193,0,0,0,0-.361L13.561,6.117a.765.765,0,0,0-.512,0L.128,10.676a.193.193,0,0,0-.005.361l12.9,5.022a.778.778,0,0,0,.558,0L25.6,11.381V17.3a1.012,1.012,0,0,0,.046,1.846,8.417,8.417,0,0,0-.621,2.624,1.02,1.02,0,0,0,2.04,0,8.441,8.441,0,0,0-.621-2.624A1.019,1.019,0,0,0,27.062,18.208Z",
    transform: "translate(0 -6.073)",
    fill: "#3f2765"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M4.888,14.87c0,1.445,0,3.145,0,3.415,0,2.69,4.049,4.88,9.14,5.017,5.09-.137,9.139-2.325,9.139-5.017,0-.268,0-1.969,0-3.415l-8.864,3.451a.769.769,0,0,1-.558,0Z",
    transform: "translate(-0.724 -7.377)",
    fill: "#3f2765"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBachelors);
export default __webpack_public_path__ + "static/media/bachelors.38c8f5bc520bdd52dd36a4f1ff368b69.svg";
export { ForwardRef as ReactComponent };